import styled, { css } from 'styled-components';
import { shade } from 'polished';
import { ButtonOptions } from '../ButtonOptions';
import { colors, radius } from '../../styles/tokens';

export const ContainerInput = styled.div`
  display: flex;

  margin: auto;
  width: 100%;

  justify-content: space-around;
  gap: 20px;

  padding: 0;
  margin: 10px auto;

  transition: border-color 0.5s;
`;

export const ContainerContainerMidia = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export const ContainerMidia = styled.div`
  display: flex;

  justify-content: center;

  overflow: hidden;

  width: 180px;
  height: 180px;

  background-color: ${colors.surfaceContainer};
  border: 1px solid ${colors.outlineVariant};

  border-radius: 50%;

  @media (max-width: 1199px) {
    width: 150px;
    height: 150px;
  }

  img {
    width: auto;
    height: 100%;

    border-radius: ${radius.sm};
  }
`;

export const ContainerButton = styled.div`
  display: flex;

  flex: 1;

  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
`;

interface IButtonProps {
  removeStyle?: boolean;
}

export const Button = styled(ButtonOptions)<IButtonProps>`
  width: 210px;
  height: 40px;

  font-size: 14px;

  ${props =>
    props.removeStyle &&
    css`
      background-color: ${colors.surfaceContainerHighest};
      color: ${colors.onSurface};

      &:hover {
        background-color: ${shade(0.2, colors.surfaceContainerHighest)};
      }
    `}

  @media (max-width:1199px) {
    width: 35px;
    height: 35px;

    span {
      display: none;
    }
  }
`;

export const Input = styled.input`
  display: none;
  flex: 1;
  padding: 0 10px;
  border: none;
  background-color: transparent;

  color: ${colors.onSurface};

  font-size: 22px;
  font-weight: 500;
`;
